import { TLLogo } from '@/components/design-system/atoms/information/TLLogo'
import { TLSpinner } from '@/components/design-system/atoms/information/TLSpinner'
import { TLTitle } from '@/components/design-system/atoms/information/TLTitle'

export const TLAtomsInformation = {
  Logo: TLLogo,
  Spinner: TLSpinner,
  Title: TLTitle
}
